import { DrawerStyleConfig } from '../types/drawer-style-config';

/**
 * "defineMultiStyleConfig" and "definePartsStyle" are not used here because their type restrictions prevent us from implementing our requirements.
 * Further investigation is needed to find a workaround for using defineMultiStyleConfig, but the current approach works perfectly fine.
 */
export const styleConfig: DrawerStyleConfig = {
  baseStyle: {
    dialogContainer: {
      display: 'flex',
      zIndex: 'modal',
      justifyContent: 'center',
    },
    dialog: {
      zIndex: 'modal',
      maxH: '100vh',
      color: 'inherit',
    },
  },
  sizes: {
    full: {
      dialog: { maxW: '100vw', h: '100vh' },
    },
    xl: {
      dialog: {
        maxW: '4xl',
      },
    },
    lg: {
      dialog: {
        maxW: '2xl',
      },
    },
    md: {
      dialog: {
        maxW: 'lg',
      },
    },
    sm: {
      dialog: {
        maxW: 'md',
      },
    },
    xs: {
      dialog: {
        maxW: 'xs',
      },
    },
  },
  defaultProps: {
    size: 'xs', // TBD - should be 'md' or 'xs'?
  },
};
